/**
 * create initial configuration state to set which column will be sorted desc
 * @param level
 * @param parsedCheck
 * @return {{}|{sortBy: [{id, desc: boolean}]}}
 */
export const initialStateHelper = ({ generatedCols, parsedCheck }) => {
    if (parsedCheck.toLowerCase() === 'work settings applied') return {};
    if (generatedCols) {
        const item = generatedCols.find((i) => i.colorable);
        if (!item) {
            return {};
        }
        return {
            sortBy: [
                {
                    id: item.accessor,
                    desc: true,
                },
            ],
        };
    } else {
        return {};
    }
};
